import { AssignKioskRepository } from '../data/assign-kiosk-repository';

export interface RegisterKioskResult {
  hasError: boolean;
  errorMessage?: string;
}

export class RegisterKioskUseCase {
  constructor(private readonly repository: AssignKioskRepository) {}

  async execute(
    machineId: string,
    countryCode: string,
    partyId: string,
    locationId: string,
    settingsJson: string
  ): Promise<RegisterKioskResult> {
    try {
      await this.repository.registerKiosk(machineId, countryCode, partyId, locationId, settingsJson);
      return { hasError: false };
    } catch (error) {
      const errorMessage = 'Unknown error occurred';
      return { hasError: true, errorMessage };
    }
  }
}
